import styled from 'styled-components';

export const AnalyticsDashRoot = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 0;
`;

export const AnalyticsDashHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 8px;
`;

export const AnalyticsDashTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const AnalyticsDashMainTitle = styled.h1`
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#111827')};
    font-family: var(--font-family-geist);
    @media (max-width: 480px) {
        font-size: 22px;
    }
`;

export const AnalyticsDashSubtitle = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.55)' : '#6b7280')};
    font-family: var(--font-family-geist);
`;

export const AnalyticsDashHeaderActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
`;

export const AnalyticsFilterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 20px 0 24px;
    & .ant-select {
        min-width: 160px;
    }
`;

export const AnalyticsKpiGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 24px;
    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }
    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const AnalyticsKpiCard = styled.div`
    background: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#1f1f1f' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? '#2c2c2c' : '#e5e7eb')};
    border-radius: 12px;
    padding: 16px;
    box-shadow: ${({ theme }) =>
        theme.colors.background.default === '#141414' ? 'none' : '0 1px 2px rgba(0,0,0,0.05)'};
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 120px;
`;

export const AnalyticsKpiTopRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
`;

export const AnalyticsKpiIconBox = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $bg }) => $bg || 'rgba(59, 130, 246, 0.12)'};
    color: ${({ $fg }) => $fg || '#3b82f6'};
`;

export const AnalyticsKpiTrend = styled.span`
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    color: ${({ $up }) => ($up ? '#16a34a' : '#dc2626')};
`;

export const AnalyticsKpiLabel = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.65)' : '#6b7280')};
    line-height: 1.3;
`;

export const AnalyticsKpiValue = styled.div`
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#111827')};
    font-family: var(--font-family-geist);
`;

export const AnalyticsSection = styled.section`
    margin-bottom: 28px;
`;

export const AnalyticsSectionHeading = styled.h2`
    margin: 0 0 16px;
    font-size: 17px;
    font-weight: 600;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#111827')};
    font-family: var(--font-family-geist);
`;

export const AnalyticsThreeCol = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    align-items: stretch;
    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
    }
`;

export const AnalyticsTwoCol = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const AnalyticsPanel = styled.div`
    background: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#1f1f1f' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? '#2c2c2c' : '#e5e7eb')};
    border-radius: 12px;
    padding: 18px 20px;
    box-shadow: ${({ theme }) =>
        theme.colors.background.default === '#141414' ? 'none' : '0 1px 2px rgba(0,0,0,0.05)'};
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const AnalyticsPanelTitle = styled.div`
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 4px;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#111827')};
`;

export const AnalyticsPanelSub = styled.div`
    font-size: 12px;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.5)' : '#9ca3af')};
    margin-bottom: 12px;
`;

export const AnalyticsChartBody = styled.div`
    flex: 1;
    min-height: 220px;
    width: 100%;
    min-width: 0;
`;

export const AnalyticsChartBodySm = styled(AnalyticsChartBody)`
    min-height: 200px;
`;

export const AnalyticsProgressList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const AnalyticsProgressRow = styled.li`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const AnalyticsProgressName = styled.span`
    flex: 0 0 120px;
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.85)' : '#374151')};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AnalyticsProgressTrack = styled.div`
    flex: 1;
    height: 8px;
    border-radius: 999px;
    background: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#2c2c2c' : '#f3f4f6')};
    overflow: hidden;
`;

export const AnalyticsProgressFill = styled.div`
    height: 100%;
    border-radius: 999px;
    width: ${({ $pct }) => `${Math.min(100, Math.max(0, $pct))}%`};
    background: #3b82f6;
`;

export const AnalyticsProgressPct = styled.span`
    flex: 0 0 42px;
    text-align: right;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.75)' : '#4b5563')};
`;

export const AnalyticsDeliveryStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 8px;
`;

export const AnalyticsDeliveryBox = styled.div`
    padding: 14px 16px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    ${({ $variant, theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        const neutralBorder = isDark ? 'rgba(255,255,255,0.12)' : '#e5e7eb';
        const neutralColor = isDark ? 'rgba(255,255,255,0.88)' : '#374151';
        if ($variant === 'green')
            return 'background: rgba(34, 197, 94, 0.15); color: #16a34a; border: 1px solid rgba(34, 197, 94, 0.35);';
        if ($variant === 'red')
            return 'background: rgba(239, 68, 68, 0.12); color: #dc2626; border: 1px solid rgba(239, 68, 68, 0.35);';
        return `background: transparent; color: ${neutralColor}; border: 1px solid ${neutralBorder};`;
    }}
`;

export const AnalyticsQaMetricRow = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-top: 8px;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const AnalyticsQaMetricCard = styled.div`
    padding: 14px 16px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    ${({ $tone }) =>
        $tone === 'blue'
            ? 'background: rgba(59, 130, 246, 0.12); color: #2563eb; border: 1px solid rgba(59, 130, 246, 0.35);'
            : $tone === 'yellow'
              ? 'background: rgba(234, 179, 8, 0.15); color: #ca8a04; border: 1px solid rgba(234, 179, 8, 0.4);'
              : 'background: rgba(34, 197, 94, 0.12); color: #16a34a; border: 1px solid rgba(34, 197, 94, 0.35);'}
`;

export const AnalyticsContributorList = styled.ul`
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const AnalyticsContributorRow = styled.li`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const AnalyticsAvatar = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
`;

export const AnalyticsContributorMeta = styled.div`
    flex: 1;
    min-width: 0;
`;

export const AnalyticsContributorName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#111827')};
`;

export const AnalyticsContributorRole = styled.div`
    font-size: 12px;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.5)' : '#6b7280')};
`;

export const AnalyticsContributorScore = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: #3b82f6;
`;

export const AnalyticsActivityList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const AnalyticsActivityItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 13px;
`;

export const AnalyticsActivityDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 5px;
    flex-shrink: 0;
    background: ${({ $tone }) =>
        $tone === 'green' ? '#22c55e' : $tone === 'yellow' ? '#eab308' : '#3b82f6'};
`;

export const AnalyticsActivityText = styled.div`
    flex: 1;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.88)' : '#374151')};
`;

export const AnalyticsActivityTime = styled.div`
    font-size: 12px;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.45)' : '#9ca3af')};
    margin-top: 2px;
`;

export const AnalyticsFooterGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
    }
`;
